import { createRouter } from './router'
import { routes } from './routes'

export const router = createRouter(routes)
